<script>
import Vue from "vue";
import panzoom from 'panzoom';

export default {
  props: {
    template: String,
    elements: Array
  },
  data() {
    return {
      templateRender: null,
      currentIndex: -1,
      offset: { }
    }
  },
  methods: {
    startDrag(event, index) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.currentIndex = index;
      this.offset = this.getMousePosition(event);
      this.offset.x -= parseFloat(this.elements[this.currentIndex].x);
      this.offset.y -= parseFloat(this.elements[this.currentIndex].y);
      document.addEventListener("mousemove", this.drag);
    },
    drag(event) {
      event.preventDefault();
      const coord = this.getMousePosition(event);
      this.elements[this.currentIndex].x = coord.x - this.offset.x;
      this.elements[this.currentIndex].y = coord.y - this.offset.y;
    },
    drop() {
      if (this.elements[this.currentIndex]) {
        this.elements[this.currentIndex].highlighted = false;
      }
      document.removeEventListener("mousemove", this.drag);
    },
    getMousePosition(event) {
      const CTM = document.getElementById("theG").getScreenCTM();
      return {
        x: (event.clientX - CTM.e) / CTM.a,
        y: (event.clientY - CTM.f) / CTM.d
      };
    },
    getFontSize(element) {
      if (element.highlighted) {
        return Math.round(element.fontSize * 1.7);
      }
      return element.fontSize;
    },
    getIdNewLabel(id){
      return `editable_text_${id}`
    },
    getFontFamily(element) {
      return element.fontFamily;
    },
    emitLabelDoubleClick(event, index) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.$emit('labelClicked', index);
    },
  },
  render(h) {
    if (!this.templateRender) {
      return h("div", "loading...");
    } else {
      return this.templateRender();
    }
  },
  watch: {
    template: {
      immediate: true,
      handler() {
        const res = Vue.compile(this.template);

        this.templateRender = res.render;
        // staticRenderFns belong into $options,
        // appearantly
        this.$options.staticRenderFns = [];

        // clean the cache of static elements
        // this is a cache with the results from the staticRenderFns
        this._staticTrees = [];

        // Fill it with the new staticRenderFns
        for (var i in res.staticRenderFns) {
          //staticRenderFns.push(res.staticRenderFns[i]);
          this.$options.staticRenderFns.push(res.staticRenderFns[i]);
        }
      }
    }
  },
  updated() {
    panzoom(document.getElementById("theG"), { smoothScroll: false });
  }
};
</script>
